export default __webpack_public_path__ + "static/media/odyssey.aebb9077.jpg";